import { SkeletonBlock } from '@/src/components/ui/SkeletonBlock';
import { placeholderData, placeholderPhoto } from './listingCardPlaceholder.styles';

/** Width is the caller's job — the 4:3 photo takes its height from the carousel item. */
export function ListingCardPlaceholder() {
  return (
    <div>
      <SkeletonBlock radius="md" className={placeholderPhoto} />
      <div className={placeholderData} />
    </div>
  );
}
